module.exports = __webpack_public_path__ + "img/reward_star.ad03be6c.png";